<template>
  <div>
    <div class="bigbox" style="background-color: #00a4a7">
      <nav class="logo">
        <img src="@/assets/Nav_bar_logo.png" alt="logo" srcset="" />
        <nav
          v-for="(item, index) in title"
          :key="index"
          @click="goto(index)"
          class="Nav_bar"
        >
          {{ item }}
        </nav>
        <el-dropdown
          popper-class="dropDownStyle"
          class="dropDown"
          @command="goto"
        >
          <el-button class="NavButton" type="primary">
            首页<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="0">首页</el-dropdown-item>
            <el-dropdown-item command="1">关于杏一</el-dropdown-item>
            <el-dropdown-item command="2">线上购物</el-dropdown-item>
            <el-dropdown-item command="3">联系我们</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
      title: ["首页", "关于杏一", "线上购物", "联系我们"],
    };
  },
  methods: {
    goto(index) {
      if (index == 0) {
        let scrollDom = document.getElementById("navbars");
        scrollDom.scrollIntoView();
      } else if (index == 1) {
        let scrollDom = document.getElementById("componys");
        // scrollDom.scrollIntoView();
        let scroll = scrollDom.getBoundingClientRect();
        // console.log(scroll.top,111);
        if ((window, innerWidth > 1366)) {
          window.scrollTo(50, scrollDom.offsetTop - 88);
        } else window.scrollTo(50, scrollDom.offsetTop - 60);
        // document.documentElement.scrollTop=scrollDom.offsetTop-88
        // document.body.scrollTop=document.scrollDom.offsetTop-88
        //  window.pageYOffset.scrollTop=document.scrollDom.offsetTop-88
      } else if (index == 2) {
        let scrollDom = document.getElementById("shoppings");
        // scrollDom.scrollIntoView();
        // console.log(scrollDom.scrollIntoView());
        if ((window, innerWidth > 1366)) {
          window.scrollTo(50, scrollDom.offsetTop - 88);
        } else window.scrollTo(50, scrollDom.offsetTop - 60);
        //         document.documentElement.scrollTop=scrollDom.offsetTop-88
        // document.body.scrollTop=document.scrollDom.offsetTop-88
        //  window.pageYOffset.scrollTop=document.scrollDom.offsetTop-88
      } else if (index == 3) {
        let scrollDom = document.getElementById("profiles");
        // scrollDom.scrollIntoView();
        if ((window, innerWidth > 1366)) {
          window.scrollTo(50, scrollDom.offsetTop - 88);
        } else window.scrollTo(50, scrollDom.offsetTop - 60);
        //         document.documentElement.scrollTop=scrollDom.offsetTop-88
        // document.body.scrollTop=document.scrollDom.offsetTop-88
        //  window.pageYOffset.scrollTop=document.scrollDom.offsetTop-88
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.bigbox {
  width: 100%;
  z-index: 1000;
  position: fixed;
}
.logo {
  @media (max-width: 1366px) {
    width: 800px;
    height: 60px;
  }
  @media (max-width: 768px) {
    width: 300px;
    height: 60px;
  }
  .dropDown {
    display: none;
  }
  width: 1020px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  height: 88px;
  background-color: #00a4a7;
}
// .Nav_bar{
//   width: 20px;
//   height: 20px;
//   padding: 50px;
//   background-color: #fff;
// }
nav .Nav_bar {
  color: #ffffff;
  padding: 15px 0px 15px 50px;
  position: relative;
  text-align: center;
  border-bottom: transparent;
  display: flex;
  transition: 0.4s;

  font-size: 20px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  line-height: 0px;
}
nav .Nav_bar:hover {
  cursor: pointer;
}

@media (max-width: 768px) {
  .logo {
    @media (max-width: 768px) {
      height: 60px;
      > img {
        width: 200px;
        height: 40px;
      }
    }
    .dropDown {
      display: block;
      background-color: #00a4a7;
      > button {
        background-color: #00a4a7;
      }
      > li {
        background: #00a4a7;
      }
    }
    .NavButton {
      border-color: #00a4a7;
      .SelectItem:hover {
        background-color: #00a4a7 !important;
      }
    }
    width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 88px;
    background-color: #00a4a7;
  }
  // .Nav_bar{
  //   width: 20px;
  //   height: 20px;
  //   padding: 50px;
  //   background-color: #fff;
  // }
  nav .Nav_bar {
    color: #ffffff;
    padding: 15px 0px 15px 15px;
    position: relative;
    text-align: center;
    border-bottom: transparent;
    display: flex;
    transition: 0.4s;

    font-size: 20px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    line-height: 0px;

    display: none;
  }
  nav .Nav_bar:hover {
    cursor: pointer;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Navbar.vue